import { Auth } from 'aws-amplify';

type SignUpUser = {
  username: string,
  password: string,
  email: string,
  name: string,
  surname: string,
  nickname: string,
  privacy: string,
};

export async function signUp(newUserData: SignUpUser): Promise<void> {
  const { username, password, email, name, surname, nickname, privacy } = newUserData;
  try {
    const { user } = await Auth.signUp({
      username,
      password,
      attributes: {
        email,
        name,
        family_name: surname,
        nickname,
        ['custom:privacy_policy']: privacy,
      },
    });
    console.log('user', user);
  } catch (error) {
    console.log('error signing up:', error);
  }
}

type ConfrimSignUp = {
  username: string,
  code: string
};

export async function confirmSignUp({ username, code }: ConfrimSignUp): Promise<void | string | unknown> {
  try {
    const res = await Auth.confirmSignUp(username, code);
    return res;
  } catch (error) {
    return error;
  }
}

type ResendConfirmation = {
  username: string,
};

export async function resendConfirmationCode({ username }: ResendConfirmation): Promise<void | string | unknown> {
  try {
    await Auth.resendSignUp(username);
    return ('SUCCESS');
  } catch (error) {
    return (error);
  }
}